import React__default, { useMemo } from 'react';
import '../../hooks/index.js';
import '../Menu/index.js';
import useSelectContext, { SelectContextProvider } from './SelectContext.js';
import useId from '../../hooks/useId/useId.js';
import SubMenu from '../Menu/SubMenu.js';

const SubSelect = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    label,
    onIsOpenChange,
    children,
    isDisabled,
    ...rest
  } = _ref;
  const paneId = useId();
  const selectContext = useSelectContext();
  const {
    selectedValues,
    GetSelectItemsFrom,
    setSelectedValues
  } = selectContext;
  const allSelectItemChildren = useMemo(() => {
    var _GetSelectItemsFrom;
    return (_GetSelectItemsFrom = GetSelectItemsFrom === null || GetSelectItemsFrom === void 0 ? void 0 : GetSelectItemsFrom(children)) !== null && _GetSelectItemsFrom !== void 0 ? _GetSelectItemsFrom : [];
  }, [children, GetSelectItemsFrom]);
  const checkedState = useMemo(() => {
    const selectedChildCount = allSelectItemChildren.filter(_ref2 => {
      let [value] = _ref2;
      return Array.isArray(selectedValues) ? selectedValues.includes(value) : selectedValues === value;
    }).length;
    const childCount = allSelectItemChildren.length;
    let result = 'mixed';
    if (selectedChildCount === childCount) {
      result = true;
    } else if (selectedChildCount === 0) {
      result = false;
    }
    return result;
  }, [allSelectItemChildren, selectedValues]);
  const onTriggerCheckboxSelect = e => {
    if (isDisabled) {
      return;
    }
    e === null || e === void 0 || e.stopPropagation();
    setSelectedValues === null || setSelectedValues === void 0 || setSelectedValues(previouslySelectedValues => {
      // exclude duplicates
      const prevSet = new Set(previouslySelectedValues);
      if (checkedState === true) {
        allSelectItemChildren.forEach(_ref3 => {
          let [value] = _ref3;
          return prevSet.delete(value);
        });
      } else {
        allSelectItemChildren.forEach(_ref4 => {
          let [value] = _ref4;
          return prevSet.add(value);
        });
      }
      return Array.from(prevSet);
    });
  };
  const subSelectPaneProps = {
    role: 'group',
    id: paneId
  };
  const subSelectTriggerProps = {
    role: 'treeitem',
    'aria-haspopup': undefined,
    'aria-owns': paneId
  };
  const sharedSubMenuProps = {
    ...rest,
    isDisabled,
    onIsOpenChange,
    label,
    ref
  };
  return /*#__PURE__*/React__default.createElement(SelectContextProvider, {
    value: {
      ...selectContext,
      subSelectTriggerProps,
      subSelectPaneProps,
      triggerCheckedState: checkedState,
      onTriggerCheckboxSelect
    }
  }, /*#__PURE__*/React__default.createElement(SubMenu, sharedSubMenuProps, children));
});

export { SubSelect as default };
